<template>
<div class="modalContents__object10" data-modalContents="thanks02">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-lg-7 col-md-8 col-10 mx-auto row no-gutters">
                <p class="col-12 text-center"><strong>ようこそ！ニューズ・オプエドへ！</strong><br><br>この度はご登録ありがとうございました。<br>ご登録メールアドレスに<br>ご登録内容のメールを<br>送信しましたのでご確認ください。<br><br>コメンテーターのプライドを賭けた<br>情熱報道ライブをお楽しみください！</p>
                <div class="col-md-8 mx-auto">
                    <a href="javascript:void(0);" class="text-center globalModal--btn" @click='showModalLogin'>ログインページへ</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapMutations } from "vuex";
import MultiModalMixin from "../mixins/ModalMixin";
export default {
  name: "RegistThanks",
  mixins: [MultiModalMixin],
  mounted () {
    this.$store.state.inputData.email = '';
    this.$store.state.inputData.last_name = '';
    this.$store.state.inputData.first_name = '';
    this.$store.state.inputData.phone = '';
    this.$store.state.inputData.password = '';
    this.$store.state.inputData.birthday = '';
    this.$store.state.inputData.gender = '';
    this.$store.state.inputData.mm01 = '';
    this.$store.state.inputData.payment_token = '';
    this.$store.state.inputData.bank_month = '';
    this.$store.state.inputData.bank_name = '';
    this.$store.state.inputData.payment_type = '';
    this.$store.state.inputData.plan = '';
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/regist_thanks.vue